import Joi from '@hapi/joi';

export const passwordRules = () =>
  Joi.string()
    .pattern(new RegExp('[A-Z]'))
    .pattern(new RegExp('[!@#$%^&*(),.?":{}|<>]'))
    .pattern(new RegExp('[a-z]'))
    .pattern(new RegExp('[0-9]'))
    .min(12)
    .required()
    .messages({
      'string.empty': 'REQUIRED_FIELD',
      'string.pattern.base': 'PASSWORD_RULES',
      'string.min': 'PASSWORD_RULES',
    });

export const passwordLessRules = () =>
  Joi.string()
    .pattern(new RegExp('[A-Z]'))
    .pattern(new RegExp('[a-z]'))
    .pattern(new RegExp('[0-9]'))
    .required()
    .messages({
      'string.empty': 'REQUIRED_FIELD',
      'string.pattern.base': 'PASSWORD_RULES',
    });

export const emailRules = () =>
  Joi.string()
    .email({
      minDomainSegments: 2,
      tlds: { allow: false },
    })
    .required()
    .messages({
      'string.email': 'NOT_VALID_EMAIL',
      'string.empty': 'REQUIRED_FIELD',
    });

export const nameRules = () =>
  Joi.string()
    .pattern(
      new RegExp(
        /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u
      )
    )
    .max(155)
    .required()
    .messages({
      'string.empty': 'REQUIRED_FIELD',
      'string.max': 'STRING_MAX',
      'string.pattern.base': 'NAME_RULES',
    });

export const userNameRules = () =>
  Joi.string()
    .pattern(
      new RegExp(
        /^[-_.a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+$/u
      )
    )
    .max(20)
    .required()
    .messages({
      'string.empty': 'REQUIRED_FIELD',
      'string.max': 'STRING_MAX_20_CHARACTERS',
      'string.pattern.base': 'USERNAME_RULES',
    });
